export default {
  computed: {
    isIE() {
      return navigator.userAgent.indexOf("MSIE") !== -1 || !document.documentMode
    }
  }
}
